import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B090014FindRequest = {
  sokoCd: string;
  shohinCd: string;
} & Partial<{
  page: number;
  sort: string[];
  size: number;
}>;

export type B090014FindResponse = {
  shukayoteiYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  hikiatesu: string;
  shainCd: string;
  shainNm: string;
  juchudenpyoNo: string;
  juchuYmd: string;
};

//検索処理
export const B090014Find = (props: B090014FindRequest) => {
  return RestClient.get<PageableResponse<B090014FindResponse[]>>(
    "b090014/find",
    {
      params: props,
    }
  );
};
